import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { validString, fullContact, addressLine, postcode, city, state, validName, email, date } from "Components/shared/helpers/validations";
import { fullName } from "Utils/validations";

export const OrderNotesSchema = Yup.object().shape(
    reverseShape({
        noteType: validString.required(),
        note: validString.required(),
        noteStatus: validString.required(),
        resolvedAt: date.optional(),
    })
  );

export default OrderNotesSchema;